







import { Component, Vue, Prop } from 'vue-property-decorator'
import { membershipState } from '../../store/modules/MembershipState'
import RegisterAdditionalModalComponent from '../../components/Membership/Register/RegisterAdditionalModalComponent.vue'

@Component({
  components: { RegisterAdditionalModalComponent }
})
export default class RegisterAdditionalModal extends Vue {
  // --------------------------------------------------------------------------------------------------------------------
  // Props
  // PDFのDL-URL. 会員情報追加成功後に利用する
  @Prop() private accessUrl!: string

  // -------------------------------------------------------------------------------------------------------------------
  // getter
  get isRegisterAdditionalModalVisible(): boolean {
    return membershipState.isRegisterAdditionalModalVisible
  }
}
